import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=19e2d78f&"
import script from "./calendar.vue?vue&type=script&lang=js&"
export * from "./calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e2d78f')) {
      api.createRecord('19e2d78f', component.options)
    } else {
      api.reload('19e2d78f', component.options)
    }
    module.hot.accept("./calendar.vue?vue&type=template&id=19e2d78f&", function () {
      api.rerender('19e2d78f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/calendar.vue"
export default component.exports